import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { LeftFrame, RightFrame } from "../../components/utilities/service-framer";

export const ServiceHeader = ({
    gradText,
    normText,
    descr,
    descrImg,
    fBtnCap,
    sBtnCap,
    fColor,
    sColor,
    onStart,
    onNext
}) => {
    return (
        <div className="service-topic">
            <LeftFrame>
                <div className="service-descr">
                    <div className="descr-caption">
                        <div className="gradient-text">{gradText}</div>
                        <div className="norm-text">{normText}</div>
                    </div>
                    <div className="descr">
                        {descr}
                    </div>
                    <div className="descr-btns">
                        <button 
                            className="descr-btn st-btn bt-bl-bg"
                            style={{
                                backgroundImage: `linear-gradient(to right, ${fColor}, ${sColor}`
                            }}
                            onClick={onStart}
                        >
                            <span className="btn-cap">{fBtnCap}</span>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                        <button 
                            className="descr-btn st-btn bt-blk-bg"
                            onClick={onNext}
                        >
                            <span className="btn-cap">{sBtnCap}</span>
                        </button>
                    </div>
                </div>
            </LeftFrame>
            <RightFrame>
                <div className="service-img descr-child glassy-effect">
                    <img src={descrImg} alt="" className="descr-pic" loading="lazy" />
                </div>
            </RightFrame>
        </div>
    )
}